import React from 'react';
import { useWatch } from 'react-hook-form';
import ToggleField from '../../toggle-field';
import ToggleSectionLayout from './layout';
const ToggleSectionField = ({
  control,
  name,
  rules = undefined,
  onChange = Function.prototype,
  ...layoutProps
}) => {
  const fieldValue = useWatch({ control, name });
  const isContentVisible = !!fieldValue;

  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
    <ToggleSectionLayout
      {...layoutProps}
      isContentVisible={isContentVisible}
      toggleSlot={
        <ToggleField
          size="small"
          control={control}
          name={name}
          rules={rules}
          onChange={handleChange}
        />
      }
    />
  );
};

export default ToggleSectionField;
